import React from 'react';
import './Checkbox.css';

interface CheckboxProps {
  onChange?: (isChecked: boolean) => void;
  isDisabled?: boolean;
  isChecked: boolean;
  label?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  isDisabled = false,
  isChecked,
  onChange,
  label = '',
}) => {

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.checked;
    onChange && onChange(newValue);
  };

  return (
    <div className='checkbox-container'>
      <input
        type='checkbox'
        className={`
          ${isDisabled ? 'isDisabled' : ''} 
        `}
        checked={isChecked}
        onChange={handleChange}
        disabled={isDisabled}
      />
      <span>{label}</span>
    </div>
  );
};

export default Checkbox;
